import React from 'react';
import { Alert, Typography } from '@mui/material';

export default function SuncareInProgressNotice() {
  return (
    <Alert severity='warning' sx={{ mb: 2 }}>
      <Typography variant='body2' fontWeight='bold' gutterBottom>
        Contract in progress
      </Typography>
      <Typography variant='body2'>
        Your contract has been sent and is pending the National Sales
        Director&apos;s counter-signature. You cannot request appointments for
        Suncare until this step is complete.
      </Typography>
    </Alert>
  );
}
